// src/config.js



export const logoPath = `${process.env.PUBLIC_URL}/images/responsive/deni_round-128.webp`;
export const logoBackPath = `${process.env.PUBLIC_URL}/images/responsive/deni_round-128.webp`; // Rückseite


// Pfad zum Logo im public-Ordner

export const socialMediaLinks = {
    linkedin: "https://www.linkedin.com/in/denisbitter/",
    instagram: "https://instagram.com/denisbitter",
    youtube: "https://www.youtube.com/@denisbitterfullstack",
    github:"https://github.com/THEORIGINALBITTER?tab=repositories",
   stack:"https://stackoverflow.com/users/30975694/denisbitter"
  };
  
  export const contactInfo = {
    email: "saghallo@denisbitter.de",
    phone: "0151 53 23 17 91",
  };

  export const instagramLinks = {
    post1: "https://www.instagram.com/reel/DAJi6D0qns3/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",

  }




  export const telNummer ={
    text: "0151 53 23 17 91",
    value: "+4915153231791"

  };

  export const mail ={
    text: "saghallo@denisbitter.de",
    value:"saghallo@denisbitter.de"

  };

  export const loginInfo = {
    text: "Zugang für Teilnehmer"
  };

  export var loginName = {
    text: "Dein Cockpit"
  }
  
  export const footerText = "Vor Ort oder Online mit echten Projekten.";

  export const bgFooter = `linear-gradient(0deg, rgba(255,255,255,0.95), rgba(255,255,255,0.95)), linear-gradient(127.36deg, #222 0%, #f0f0f0 100%)`;

  export const copyrightText = "© 2014–2026 Denis Bitter — designed & built from scratch";
